export default {
    name: 'SnowFuze',
    logoVariant: 'light',
    logo: {
        square: '/src/brands/default/assets/square.png',
    },
    pwa: {
        name: 'SnowFuze Resort Management',
        shortName: 'SnowFuze',
        themeColor: '#16a085',
        backgroundColor: '#ffffff',
        gcm_sender_id: "103953800507",
        vapidPublicKey: 'BO6LHTcktRG1xwi5WAKtKKzmOy-Y4v1rr0Etqw8gXY5vYolkQATa1iHs_pq44R8XVOGm1UaI-lurI_ggeZQxv2E'
    }
}